import React, { useEffect, useState } from 'react';

const SignupGiftCompleted = () => {
    const [email, setEmail] = useState(null);
    const [link, setLink] = useState(null);
    // Only allow user to access this page through redirect from the booking
    useEffect(() => {
        axios
            .get("/api/custodian/activation")
            .then(response => {
                setEmail(response.data.email);
                setLink(response.data.link);
            });
    }, []);

    if (email == null || link == null) {
        return null;
    }

    return (
        <div id="signupGiftCompleted" className="container">
            <h1>You're all set!</h1>
            <p>Make sure to let give the Member the email you signed him up with and the link!</p>
            <p><strong>Email:</strong> {email}</p>
            <p><strong>Link:</strong> {link}</p>
        </div>
    )
}

export default SignupGiftCompleted;
